import { PageInfoService } from '@pulse/browser-shared';
import { PulseModule, SettingsConfigurations } from '@pulse/common';
import { pulseSettingsdefaultConfigs } from './configuration';
import { settingsProviders } from './providers';
import { CookieSyncService } from './services/cookie-sync.service';

const SETTINGS_BASE_URL_BY_ENV: Record<string, string> = {
    prod: 'https://optifyr.com/web/v2',
    stage: 'https://stage.optifyr.com/web/v2',
};

function buildConfig(
    userConfig: Partial<SettingsConfigurations>,
): Required<SettingsConfigurations> {
    return {
        ...pulseSettingsdefaultConfigs,
        ...userConfig,
    };
}

export const SettingsModule = new PulseModule<SettingsConfigurations>()
    .provide(settingsProviders)
    .beforeInit(buildConfig)
    .onInit(
        async (
            config: SettingsConfigurations,
            cookieSyncService: CookieSyncService,
            page: PageInfoService,
        ) => {
            const environment = page.url().searchParams.get('pa_env');

            if (environment && SETTINGS_BASE_URL_BY_ENV[environment]) {
                config.settingsBaseURL = SETTINGS_BASE_URL_BY_ENV[environment];
            }
            cookieSyncService.startService();
        },
        [CookieSyncService, PageInfoService],
    );
